import { addStyles } from 'ethcss'
import { grid, IStyles } from 'theme'

const displaysMoveSettingsStyles: IStyles = {
    wrapper: {
        ...grid.col,
        ...grid.full,
        ...grid.justify,
        overflow: 'visible',
    },
    buttons: {
        ...grid.row,
        ...grid.center,
        ...grid.pt_big,
    },
}

addStyles(displaysMoveSettingsStyles)
export default displaysMoveSettingsStyles
